import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=2da938b0&scoped=true&"
import script from "./FeedbackCard.vue?vue&type=script&lang=ts&"
export * from "./FeedbackCard.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=2da938b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da938b0",
  null
  
)

export default component.exports